function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0.000610352C4.47768 0.000610352 0 4.47829 0 10.0006C0 15.5229 4.47768 20.0006 10 20.0006C15.5223 20.0006 20 15.5229 20 10.0006C20 4.47829 15.5223 0.000610352 10 0.000610352ZM10 18.3042C5.41518 18.3042 1.69643 14.5854 1.69643 10.0006C1.69643 5.41579 5.41518 1.69704 10 1.69704C14.5848 1.69704 18.3036 5.41579 18.3036 10.0006C18.3036 14.5854 14.5848 18.3042 10 18.3042Z",
  fill: "#899296"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8995 12.8264L10.7164 10.5251V5.00059C10.7164 4.90238 10.6361 4.82202 10.5379 4.82202H9.46422C9.366 4.82202 9.28564 4.90238 9.28564 5.00059V11.1479C9.28564 11.2059 9.31243 11.2595 9.3593 11.293L13.0513 13.9849C13.1316 14.043 13.2432 14.0251 13.3013 13.947L13.9396 13.0764C13.9977 12.9939 13.9798 12.8823 13.8995 12.8264Z",
  fill: "#899296"
});

var SvgIcClock = function SvgIcClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_clock.476accb0.svg";
export { ForwardRef as ReactComponent };